module.exports = __webpack_public_path__ + "img/ferhat.d703b768.jpg";